import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "../styles/Navbar.css";
import ReorderIcon from "@mui/icons-material/Reorder";
import { Link as ScrollLink } from "react-scroll";

function Navbar() {
  const [expandNavbar, setExpandNavbar] = useState(false);


  const location = useLocation();

  useEffect(() => {

    setExpandNavbar(false);


  }, [location]);


  const setExpandNavbarTrueorfalse = () => {
    if (window.innerWidth <= 768) {
      setExpandNavbar((prev) => !prev);

    }
  }




  return (
    <div className="navbar" id={expandNavbar ? "open" : "close"}>
      <div className="toggleButton">
        <button
          onClick={setExpandNavbarTrueorfalse}
        >
          <ReorderIcon />
        </button>
      </div>
      <div className="links">
        <ScrollLink style={{ cursor: "pointer" }}  onClick={setExpandNavbarTrueorfalse} to="home" spy={true} smooth={true} offset={-50} duration={500}>
          Home
        </ScrollLink>
        <ScrollLink style={{ cursor: "pointer" }}  onClick={setExpandNavbarTrueorfalse} to="projects" spy={true} smooth={true} offset={-50} duration={500}>
          Projects
        </ScrollLink>
        <a href="../assets/Arpit-Rajput-resume" download="Arpit-Rajput-resume.pdf">Resume</a>
      </div>
    </div>
  );
}

export default Navbar;
